import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import NotFound from "@/pages/NotFoundPage.vue";
import Dashboard from "@/pages/Dashboard.vue";
import TableList from "@/pages/TableList.vue";
import Cotacao from "@/pages/Cotacao.vue";
import Mundos from "@/pages/Mundos.vue";
import Comparador from "@/pages/Comparador.vue";
import Sobre from "@/pages/Sobre.vue";
import Varinhas from "@/pages/Varinhas.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
      },
      {
        path: "table-list",
        name: "table-list",
        component: TableList,
      },
      {
        path: "cotacao",
        name: "cotacao",
        component: Cotacao,
      },
      {
        path: "mundos",
        name: "mundos",
        component: Mundos,
      },
      {
        path: "comparador",
        name: "comparador",
        component: Comparador,
      },
      {
        path: "sobre",
        name: "sobre",
        component: Sobre,
      },
      {
        path: "varinhas",
        name: "varinhas",
        component: Varinhas,
      },
    ],
  },
  { path: "*", component: NotFound },
];

export default routes;
